import React, { useContext } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { UserContext } from '../../App';
const backdropUseStyles = makeStyles((theme) => ({ backdrop: { zIndex: theme.zIndex.drawer + 1, color: '#fff' } }));

const BackDropUI = () => {
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);
    const backdropClasses = backdropUseStyles();

    return (
        <Backdrop className={backdropClasses.backdrop} open={backdropUI}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default BackDropUI;